import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { adsServer } from "../../server";

const SponsoredBrandCarouselPropsMobile = ({ ads }) => {
    const brandRefs = useRef(new Map());
    const [currentIndex, setCurrentIndex] = useState(0); 

    const logViewedImpression = async (adId) => {
        try {
            await axios.post(`${adsServer}/sponsored/viewed-impression/${adId}`, {}, {
                withCredentials: true,
                headers: {
                    'current-profile': sessionStorage.getItem('currentProfile') || 'defaultProfile',
                }
            });
            console.log('Viewed impression logged for brand:', adId);
        } catch (error) {
            console.error('Error logging viewed impression:', error);
        }
    };

    const logAdClick = async (adId) => {
        try {
            await axios.post(`${adsServer}/sponsored/click/${adId}`, {
                withCredentials: true,
                headers: {
                    'current-profile': sessionStorage.getItem('currentProfile') || 'defaultProfile',
                }
            });
            console.log('Click logged for brand ad:', adId);
        } catch (error) {
            console.error('Error logging click:', error);
        }
    };

    // Intersection observer to track impressions
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const adId = entry.target.dataset.adId;
                        const timer = setTimeout(() => {
                            logViewedImpression(adId);
                        }, 1000);
                        entry.target._timer = timer;
                    } else {
                        clearTimeout(entry.target._timer); 
                    }
                });
            },
            { threshold: 0.5 }
        );

        const visibleAds = [ads[currentIndex]];
        if (ads.length > 1) {
            visibleAds.push(ads[(currentIndex + 1) % ads.length]);
        }

        visibleAds.filter(Boolean).forEach((ad) => {
            const brandElement = brandRefs.current.get(ad._id);
            if (brandElement) {
                observer.observe(brandElement);
            }
        });

        return () => {
            observer.disconnect();
        };
    }, [currentIndex, ads]);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % ads.length);
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + ads.length) % ads.length);
    };

    const visibleAds = ads[currentIndex] ? [ads[currentIndex]] : [];
    if (ads.length > 1) {
        visibleAds.push(ads[(currentIndex + 1) % ads.length]);
    }

    return (
        <div className="sponsored-brand-ad-carousel">
            {ads.length > 1 && (
                    <>
                    <button className="sponsored-carousel-nav-button sponsored-carousel-prev" onClick={prevSlide}>‹</button>
                    <button className="sponsored-carousel-nav-button sponsored-carousel-next" onClick={nextSlide}>›</button>
                </> 
            )}
            <div className="sponsored-carousel-track">
                {visibleAds.filter(Boolean).map((ad, index) => (
                    <div
                        key={ad._id}
                        className={`sponsored-brand-ad-carousel-item-mobile sponsored-carousel-card ${index > 0 ? 'sponsored-carousel-secondary-card' : ''}`}
                        style={{ backgroundImage: `url(${ad.brand.coverImage.url})` }}
                        data-ad-id={ad._id}
                        ref={(el) => el && brandRefs.current.set(ad._id, el)}
                    >
                        <Item brand={ad.brand} logAdClick={() => logAdClick(ad._id)} />
                    </div>
                ))}
            </div>
        </div>
    );
};

const Item = ({ brand, logAdClick }) => {
    return (
        <div className="sponsored-brand-ad-carousel-content">
            <h2 className="sponsored-brand-ad-carousel-title">{brand.name}</h2>
            <p className="sponsored-brand-ad-carousel-description">{brand.description}</p>
            <Link to={`/brand/${brand.name}`} onClick={logAdClick} className="sponsored-brand-ad-carousel-button">
                Visit Brand
            </Link>
        </div>
    );
};

export default SponsoredBrandCarouselPropsMobile;